import clsx from 'clsx';
import React, { useEffect, useState } from 'react';

import { MODAL_TYPE } from '@/src/components/common/Elements/Modal/Config';
import ModalPopup from '@/src/components/common/Elements/Modal/ModalPopup/ModalPopup';

const RenameModal = (props) => {
  const { type, currentValue, onCancel, onSave } = props;

  const [updatedName, setUpdatedName] = useState(currentValue);
  const submitEnabled = updatedName !== currentValue;

  const handleCancel = () => {
    onCancel();
  };

  const handleSave = () => {
    onSave(updatedName);
  };

  const handleInputChange = (e) => {
    setUpdatedName(e.target.value);
  };

  useEffect(() => {
    setUpdatedName(currentValue);
  }, [currentValue]);

  return (
    <ModalPopup
      id={'renameFile'}
      title={`Rename ${type}?`}
      modalType={MODAL_TYPE.inverse}
      modalWidth={clsx('tw-w-[439px]')}
      onClose={handleCancel}
      onConfirm={handleSave}
      confirmBtn={{ label: 'Save', disabled: !submitEnabled }}
    >
      <input
        type="text"
        className={clsx(
          'tw-w-full',
          // (!) is not removed here as it is to override the styles from vendor.css
          '!tw-bg-cfo-grey-100 tw-placeholder-cfo-grey-600',
          '!tw-rounded-[5px]',
          'tw-py-[10px] tw-px-[15px]'
        )}
        value={updatedName}
        onChange={handleInputChange}
      />
    </ModalPopup>
  );
};

export default RenameModal;
